export const industryConstants = {
  ADD_REQUEST: 'INDUSTRY_ADD_REQUEST',
  ADD_SUCCESS: 'INDUSTRY_ADD_SUCCESS',
  ADD_FAILURE: 'INDUSTRY_ADD_FAILURE',

  GETALL_REQUEST: 'INDUSTRY_GETALL_REQUEST',
  GETALL_SUCCESS: 'INDUSTRY_GETALL_SUCCESS',
  GETALL_FAILURE: 'INDUSTRY_GETALL_FAILURE',

  DELETE_REQUEST: 'INDUSTRY_DELETE_REQUEST',
  DELETE_SUCCESS: 'INDUSTRY_DELETE_SUCCESS',
  DELETE_FAILURE: 'INDUSTRY_DELETE_FAILURE',

  GETALL_PAGE_REQUEST: 'INDUSTRY_GETALL_PAGE_REQUEST',
  GETALL_PAGE_SUCCESS: 'INDUSTRY_GETALL_PAGE_SUCCESS',
  GETALL_PAGE_FAILURE: 'INDUSTRY_GETALL_PAGE_FAILURE',

  GETBYID_REQUEST: 'INDUSTRY_GETBYID_REQUEST',
  GETBYID_SUCCESS: 'INDUSTRY_GETBYID_SUCCESS',
  GETBYID_FAILURE: 'INDUSTRY_GETBYID_FAILURE',

  UPDATE_REQUEST: 'INDUSTRY_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'INDUSTRY_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'INDUSTRY_UPDATE_FAILURE',

  UPDATE_FILTER_REQUEST: 'UPDATE_INDUSTRY_FILTER_REQUEST',
  UPDATE_FILTER_SUCCESS: 'UPDATE_INDUSTRY_FILTER_SUCCESS',
  UPDATE_FILTER_FAILURE: 'UPDATE_INDUSTRY_FILTER_FAILURE',
}
